"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpileTypes = void 0;
exports.stockpileTypes = {
    RESET: 'STOCKPILE TRANSACTIONS TYPES RESET',
    SET_POS: 'STOCKPILE TRANSACTIONS TYPES SET POS',
    SET_HEX: 'STOCKPILE TRANSACTIONS TYPES SET HEX',
    ON_DELETE: 'STOCKPILE TRANSACTIONS TYPES ON DELETE',
    SHOW_TOAST: 'STOCKPILE TRANSACTIONS TYPES SHOW TOAST',
    SET_ERROR: 'STOCKPILE TRANSACTIONS TYPES SET ERROR',
    ON_PUSH_LED: 'STOCKPILE TRANSACTIONS TYPES PUSH LED',
    GET_DETAIL: 'STOCKPILE TRANSACTIONS TYPES GET DETAIL',
    SET_STATUS: 'STOCKPILE TRANSACTIONS TYPES SET STATUS',
    DT_NOT_FOUND: 'STOCKPILE TRANSACTIONS TYPES DT NOT FOUND',
    GET_DROPDOWN: 'STOCKPILE TRANSACTIONS TYPES GET DROPDOWN',
    ON_PAGE_CHANGE: 'STOCKPILE TRANSACTIONS TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'STOCKPILE TRANSACTIONS TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'STOCKPILE TRANSACTIONS TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'STOCKPILE TRANSACTIONS TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'STOCKPILE TRANSACTIONS TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'STOCKPILE TRANSACTIONS TYPES ON CHANGE DATAITEM',
    SET_DATA_DUMPTRUCK: 'STOCKPILE TRANSACTIONS TYPES GET DATA DUMPTRUCK',
    SET_SUBMIT_LOADING: 'STOCKPILE TRANSACTIONS TYPES SET SUBMIT LOADING',
    SET_DATA_GRID_HISTORY: 'STOCKPILE TRANSACTIONS TYPES GET DATA GRID HISTORY',
    ON_PAGE_CHANGE_HISTORY: 'STOCKPILE TRANSACTIONS TYPES ON PAGE CHANGE HISTORY',
    GET_LANDING_PAGE_DATA_STOCKPILE: 'STOCKPILE TRANSACTIONS TYPES GET LANDING PAGE DATA STOCKPILE',
    SET_DATA_CONFIGURATION_STOCKPILE: 'STOCKPILE TRANSACTIONS TYPES GET DATA CONFIGURATION STOCKPILE',
};
